import {css} from 'lit';
export const styles = css`:host {
  display: flex;
  font-size: var(--font-size-sm);
}

slot[name='avatar'] {
  display: block;
  margin-right: 16px;
}

slot[name='title'] {
  margin-bottom: 4px;
  font-weight: 600;
  font-size: 1.1em;
  word-break: break-word;
}

@media (min-width: 768px) {
  slot[name='title'] {
    font-size: 1.25em;
  }
}

ef-icon[name='shield-check'] {
  color: var(--primary);
  font-size: 1.3em;
}

.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 auto;
}

ef-timeago::before {
  content: ' • ';
}

.origin {
  display: inline-block;
  margin-top: 4px;
}

:host:last-child .info {
  padding-bottom: 0;
  border-bottom: none;
}
`;
export default styles;
